import WidgetModule from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay";

export * from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay";

export default WidgetModule;
